import CitySEOHead from "@/components/feature/CitySEOHead";
import MonroeHeroSection from "./components/HeroSection";
import MonroeStickyNav from "./components/StickyNav";
import MonroeProcessingTimeSection from "./components/ProcessingTimeSection";
import MonroeServicesSection from "./components/ServicesSection";
import MonroeLocalAreaSection from "./components/LocalAreaSection";
import MonroeTravelTimingSection from "./components/TravelTimingSection";
import MonroeDestinationsSection from "./components/DestinationsSection";
import MonroeTestimonialsSection from "./components/TestimonialsSection";
import MonroeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MonroeComparisonSection from "./components/ComparisonSection";
import MonroeMistakesSection from "./components/MistakesSection";
import MonroeHowItWorksSection from "./components/HowItWorksSection";
import MonroeFAQSection, { faqs } from "./components/FAQSection";
import MonroeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MonroeFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function MonroePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Monroe"
        state="Louisiana"
        stateAbbr="LA"
        route="/monroe"
        title="Emergency Passport Monroe, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Monroe, LA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving healthcare professionals, ULM students, agricultural business travelers, and Northeast Louisiana families."
        geoPlacename="Monroe, Louisiana"
        geoPosition="32.5093;-92.1193"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Monroe travelers with immediate departure needs — as fast as 24 hours for Northeast Louisiana residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Monroe with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for ULM students and Monroe families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Monroe, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Northeast Louisiana families." },
          { name: "Name Change", description: "Passport correction and name change service for Monroe residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for healthcare professionals and agricultural business travelers from Monroe." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <MonroeHeroSection />
      <MonroeStickyNav />
      <MonroeProcessingTimeSection />
      <MonroeLocalAreaSection />
      <MonroeServicesSection />
      <MonroeTravelTimingSection />
      <MonroeDestinationsSection />
      <MonroeTestimonialsSection />
      <MonroeAcceptanceFacilitiesSection />
      <MonroeComparisonSection />
      <MonroeMistakesSection />
      <MonroeHowItWorksSection />
      <MonroeFAQSection />
      <MonroeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/monroe" state="LA" />
      <MonroeFinalCTA />
    </div>
  );
}